export default "__VITE_ASSET__DsN80G07__"